/* @flow */
import "./Bootstrap.css";
import "./App.css";

import "react-datepicker/dist/react-datepicker.css";
import "react-select/dist/react-select.css";

import Helmet from "react-helmet";
import React from "react";
import favicon from "../../common/app/favicon";
import start from "../../common/app/start";
import { Miss } from "react-router";
import { connect } from "react-redux";

import {
  refreshToken,
  setRefreshTokenInterval,
  getCurrentAdmin
} from "../../common/auth/actions";
import { confirmTransition, rejectTransition } from "../../common/app/actions";

// Pages
import Home from "../home/HomePage";
import Agency from "../agency/Page";
import Offer from "../offer/Page";
import Application from "../application/Page";
import Admin from "../admin/Page";
import User from "../user/Page";
import NotFound from "../notfound/NotFoundPage";
import SignIn from "../auth/SignInPage";
import Profile from "../profile/Page";
import Article from "../article/Page";

import AppLoader from "../components/AppLoader/AppLoader";
import Match from "../components/Match";

import ConfirmModal from "../components/ConfirmModal/ConfirmModal";
import cookie from "react-cookie";

const jwtToken = cookie.load("jwt-token");

// v4-alpha.getbootstrap.com/getting-started/introduction/#starter-template
const bootstrap4Metas: any = [
  { charset: "utf-8" },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1, shrink-to-fit=no"
  },
  {
    "http-equiv": "x-ua-compatible",
    content: "ie=edge"
  }
];

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      refreshTokenInterval: null
    };
  }

  componentDidMount() {
    const {
      refreshToken,
      setRefreshTokenInterval,
      refreshTokenInterval,
      getCurrentAdmin,
      token,
      appPath
    } = this.props;

    if (!refreshTokenInterval) {
      const interval = setInterval(async () => {
        const res = await refreshToken();
        if (res === "expired" || res === "notoken") {
          if (window.location.pathname !== `${appPath}/signin`) {
            window.location.href = `${appPath}/signin`;
          }
        }
      }, 10000);
      setRefreshTokenInterval(interval);
    }

    if (token) {
      const uid = JSON.parse(atob(token.token.split(".")[1])).uid;
      getCurrentAdmin({ uid: uid });
    }
  }

  render() {
    const {
      currentLocale,
      currentTheme,
      transitionResolve,
      confirmTransition,
      rejectTransition,
      appPath
    } = this.props;

    return (
      <div>
        <Helmet
          htmlAttributes={{ lang: currentLocale }}
          meta={[
            ...bootstrap4Metas,
            {
              name: "description",
              content:
                "Dev stack and starter kit for functional and universal React apps"
            },
            ...favicon.meta
          ]}
          link={[...favicon.link]}
          titleTemplate="%s | OpiekujSię - Panel Administracyjny"
        />
        <AppLoader />

        <ConfirmModal
          color="warning"
          title="UWAGA!"
          content="Dane nie zostały zapisane. Czy na pewno chcesz opuścić widok?"
          icon="times-circle"
          confirmButtonText="Opuść widok"
          cancelButtonText="Cofnij"
          cancelAction={rejectTransition}
          isOpen={transitionResolve !== null}
          confirmAction={confirmTransition}
        />

        <Match authorized exactly pattern={appPath} component={Home} />
        <Match
          authorized
          exactly
          pattern={`${appPath}/profile`}
          component={Profile}
        />
        <Match authorized pattern={`${appPath}/agencies`} component={Agency} />
        <Match authorized pattern={`${appPath}/offers`} component={Offer} />
        <Match
          authorized
          pattern={`${appPath}/applications`}
          component={Application}
        />
        <Match authorized pattern={`${appPath}/admins`} component={Admin} />
        <Match authorized pattern={`${appPath}/users`} component={User} />
        <Match authorized pattern={`${appPath}/articles`} component={Article} />
        <Match notAuthorized pattern={`${appPath}/signin`} component={SignIn} />
        <Miss component={NotFound} />
      </div>
    );
  }
}

App.propTypes = {
  currentLocale: React.PropTypes.string.isRequired
};

App = connect(
  state => ({
    currentLocale: state.intl.currentLocale,
    refreshTokenInterval: state.auth.refreshTokenInterval,
    transitionResolve: state.app.transitionResolve,
    token: state.auth.token,
    appPath: state.config.appPath
  }),
  {
    refreshToken,
    setRefreshTokenInterval,
    confirmTransition,
    rejectTransition,
    getCurrentAdmin
  }
)(App);

export default start(App);



// WEBPACK FOOTER //
// ./src/browser/app/App.js